import { HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { catchError, throwError } from 'rxjs';

import { AuthService } from './auth.service';

export const authInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const injector = inject(Injector);
  const auth = injector.get(AuthService);
  const token = auth.token();
  const userId = auth.user()?.id;

  const authenticatedRequest = token
    ? request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        ...(userId ? { 'user-id': String(userId) } : {}),
      },
    })
    : request;

  return next(authenticatedRequest).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && token && auth.token() === token) {
        auth.logout(true, false);
      }
      return throwError(() => error);
    }),
  );
};
